import { render } from "./UpPop.vue?vue&type=template&id=a9f85572&scoped=true"
import script from "./UpPop.vue?vue&type=script&lang=js"
export * from "./UpPop.vue?vue&type=script&lang=js"

import "./UpPop.vue?vue&type=style&index=0&id=a9f85572&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9f85572"]])

export default __exports__